import { render, staticRenderFns } from "./Press.vue?vue&type=template&id=03682142&scoped=true&lang=html"
import script from "./Press.vue?vue&type=script&lang=js"
export * from "./Press.vue?vue&type=script&lang=js"
import style1 from "./Press.vue?vue&type=style&index=1&id=03682142&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03682142",
  null
  
)

export default component.exports